__turbopack_context__.v({
  "addLightsButton": "side-drawer-module__5ydy2G__addLightsButton",
  "contentWrapper": "side-drawer-module__5ydy2G__contentWrapper",
});
